// SignInCta.tsx — signed-out call-to-action card (e.g. replaces a composer when logged out).
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ConsolePanel } from '@/ui';

export interface SignInCtaProps {
  message: string;
}

const Wrap = styled(ConsolePanel)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  flex-wrap: wrap;
`;

const Text = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;

const PrimaryLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.font.body};
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize.xs};
  padding: 6px 14px;
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid transparent;
  text-decoration: none;
  /* Secondary, not an accent fill. This component renders repeatedly down a
     signed-out feed (above the composer, between posts), so as a filled accent
     it put three or four identical accent blocks on one screen, the scarcity
     that makes an accent read as signal, spent. The persistent bottom bar is
     the one place a guest gets a filled call to action. */
  background: ${({ theme }) => theme.color.surface};
  color: ${({ theme }) => theme.color.textPrimary};
  border-color: ${({ theme }) => theme.color.hairSoft};
  transition: background 120ms ease;
`;

export function SignInCta({ message }: SignInCtaProps) {
  return (
    <Wrap role="status">
      <Text>{message}</Text>
      <PrimaryLink to="/signin">Sign in</PrimaryLink>
    </Wrap>
  );
}
